import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';
import retry from '../../retry';
import PrivateRoute from '../../components/PrivateRoute';
import ListaAlunosPreMatriculadosPage from './ListaAlunosPreMatriculadosPage';
import DetalhesPage from './DetalhesPage';

const ClassListPage = lazy(() => retry(() => import('./ClassListPage')));

export default () => (
  <Switch>
    <PrivateRoute exact path="/turma" component={ClassListPage} />
    <PrivateRoute
      exact
      path="/turma/:id/pre-matriculados"
      component={ListaAlunosPreMatriculadosPage}
    />
    <PrivateRoute
      exact
      path="/turma/:id/detalhes"
      component={DetalhesPage}
    />
  </Switch>
);
